import { useEffect } from "react"

import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useFetch from "shared/model/useFetch"
import useAuthCookie from "shared/model/useLoginCookie"
import useRoleCookie from "shared/model/useRoleCookie"

const usePostManagerLogin = (idRef, pwRef) => {
    const [fetchResult, fetchRequest] = useFetch()
    const [, setAuthCookie] = useAuthCookie()
    const [, setRoleCookie] = useRoleCookie()
    const [, setAlert] = useAlertModalAtom()



    const clickEvent = () => {
        fetchRequest("POST", "/admin/auth/manager/login", {
            "id": idRef?.current?.value,
            "password": pwRef?.current?.value
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setAuthCookie(fetchResult?.data?.token)
                setRoleCookie(fetchResult?.data?.role)
                break
            case 400:
                if (fetchResult?.data?.error_code === "id") setAlert("아이디를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "password") setAlert("비밀번호를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 403:
                if (fetchResult?.data?.error_code === 1) setAlert("아직 승인되지 않은 계정입니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("계정 정보가 존재하지 않습니다.")
                break
        }
    }, [fetchResult])


    return [clickEvent]
}

export default usePostManagerLogin